import ActivityLog from '@components/activityLog/ActivityLog'
import { useMembershipProfileContext } from '@contexts/membership/MembershipProfileContext'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Flex } from 'antd'

const ProfileActivitiesSection = () => {
  const { id } = useMembershipProfileContext()

  return (
    <Flex vertical gap={8}>
      <PageTitle
        level={5}
        title="Profile's Activities"
        style={{ margin: 0 }}
      />
      <ActivityLog.Timeline
        title=""
        entity="membership-profile"
        entityId={id}
      />
    </Flex>
  )
}

export default ProfileActivitiesSection
